/**
 * Contact supervisors for a shift: prefer shift admins when set, else sector admins.
 * @param {object|null|undefined} shift
 * @returns {array}
 */
export function shiftContactAdmins(shift) {
    if (!shift)
        return [];

    if (shift.admins?.length)
        return shift.admins;

    return shift.sector?.admins || [];
}
